/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/subtract_medium'
export default icon
